/**
 * Questionnaire v2 — Étapes 14 à 15
 * Atelier floral (participants) et matériels
 */
(function () {
  'use strict';

  let workshopParticipants = 0;

  function getLightboxEl() {
    return document.getElementById('questionnaire-image-lightbox');
  }

  function getLightboxImageEl() {
    return document.getElementById('lightbox-image');
  }

  function getUncroppedImageUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
    let url = rawUrl.trim().replace(/&amp;/g, '&');
    url = url.replace(/_\d+x\d+_crop_center(?=\.)/i, '');
    url = url.replace(/_crop_center(?=\.)/i, '');
    url = url.replace(/_\d+x\d+(?=\.)/i, '');
    url = url.replace(/_\d+x(?=\.)/i, '');
    url = url.replace(/_x\d+(?=\.)/i, '');
    url = url.replace(/([?&])width=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])height=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])crop=[^&]*(&|$)/i, '$1');
    url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');
    return url;
  }

  function openLightbox(imageSrc) {
    if (window.QV2 && typeof window.QV2.openImageLightbox === 'function') {
      return window.QV2.openImageLightbox(imageSrc);
    }
    let lightbox = getLightboxEl();
    if (!lightbox) {
      lightbox = document.querySelector('[data-qv2-section="09-13"] #questionnaire-image-lightbox') ||
        document.querySelector('.qv2-step-section #questionnaire-image-lightbox');
      if (lightbox && lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }
    }
    const lightboxImage = getLightboxImageEl();
    if (lightbox && lightboxImage && imageSrc) {
      lightboxImage.src = getUncroppedImageUrl(imageSrc);
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      return true;
    }
    return false;
  }

  function initLightboxBindings() {
    const lightboxClose = document.getElementById('lightbox-close');
    const lightbox = getLightboxEl();
    const lightboxOverlay = lightbox ? lightbox.querySelector('.lightbox-overlay') : null;
    if (lightboxClose && !lightboxClose.dataset.qv2Bound1415) {
      lightboxClose.dataset.qv2Bound1415 = '1';
      lightboxClose.addEventListener('click', function () {
        const activeLightbox = getLightboxEl();
        if (activeLightbox) {
          activeLightbox.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
    if (lightboxOverlay && !lightboxOverlay.dataset.qv2Bound1415) {
      lightboxOverlay.dataset.qv2Bound1415 = '1';
      lightboxOverlay.addEventListener('click', function () {
        const activeLightbox = getLightboxEl();
        if (activeLightbox) {
          activeLightbox.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  }

  function openMaterialHelpModal(helpId) {
    const modal = helpId ? document.getElementById('material-help-modal-' + helpId) : null;
    if (modal) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function initMaterialHelpDelegation() {
    if (document.body.dataset.qv2MaterialHelpBound) return;
    document.body.dataset.qv2MaterialHelpBound = '1';
    document.addEventListener('click', function (e) {
      const helpBtn = e.target.closest('.material-help-btn');
      if (!helpBtn) return;
      e.preventDefault();
      e.stopPropagation();
      openMaterialHelpModal(helpBtn.getAttribute('data-material-help'));
    }, true);
  }

  function initMaterialZoomDelegation() {
    if (document.body.dataset.qv2MaterialZoomBound) return;
    document.body.dataset.qv2MaterialZoomBound = '1';
    document.addEventListener('click', function (e) {
      if (e.target.closest('.material-help-btn')) return;

      const zoomBtn = e.target.closest('.material-item .image-zoom-btn');
      if (!zoomBtn) return;
      e.preventDefault();
      e.stopPropagation();
      const src = zoomBtn.getAttribute('data-lightbox-src') ||
        ((window.QV2 && window.QV2.resolveZoomImageSrc) ? window.QV2.resolveZoomImageSrc(zoomBtn) : '');
      if (src) openLightbox(src);
    }, true);
  }

  function normalizeRecommendationText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getMaterialCardByKeywords(includesKeywords, excludesKeywords) {
    const includes = includesKeywords || [];
    const excludes = excludesKeywords || [];
    return Array.from(document.querySelectorAll('.material-item')).find(function (card) {
      const titleEl = card.querySelector('.material-item-title');
      const title = normalizeRecommendationText(titleEl ? titleEl.textContent : '');
      if (!title) return false;
      const hasIncludes = includes.every(function (keyword) {
        return title.includes(normalizeRecommendationText(keyword));
      });
      const hasExcludes = excludes.some(function (keyword) {
        return title.includes(normalizeRecommendationText(keyword));
      });
      return hasIncludes && !hasExcludes;
    }) || null;
  }

  function setMaterialQuantity(card, quantity) {
    if (!card) return;
    const materialId = card.getAttribute('data-material-id');
    if (!materialId) return;
    const quantityInput = card.querySelector('#material-quantity-' + materialId);
    const minusBtn = card.querySelector('.quantity-minus[data-material-id="' + materialId + '"]');
    if (!quantityInput) return;
    const safeQuantity = Math.max(0, parseInt(quantity, 10) || 0);
    quantityInput.value = safeQuantity;
    quantityInput.disabled = safeQuantity <= 0;
    if (minusBtn) minusBtn.disabled = safeQuantity <= 0;
    card.classList.toggle('selected', safeQuantity > 0);
  }

  function readTableHonneurState() {
    const freshSelected = document.getElementById('table-honneur-fresh');
    if (!freshSelected || !freshSelected.classList.contains('selected')) {
      return { choice: null, suboption: null };
    }
    const sub = document.querySelector('.table-honneur-suboption.selected');
    return {
      choice: 'fresh',
      suboption: sub ? sub.getAttribute('data-suboption') : null
    };
  }

  function readArcheState() {
    if (document.getElementById('arche-fresh')?.classList.contains('selected')) return 'fresh';
    if (document.getElementById('arche-artificial')?.classList.contains('selected')) return 'artificial';
    return null;
  }

  function updateStep15MaterialsValidation() {
    const validateBtn = document.getElementById('validate-step-15');
    if (!validateBtn) return;
    const hasQty = Array.from(document.querySelectorAll('.material-item .quantity-input[data-material-id]')).some(function (input) {
      return (parseInt(input.value, 10) || 0) > 0;
    });
    const noBtn = document.getElementById('no-materials-btn');
    const noSelected = noBtn && noBtn.classList.contains('selected');
    validateBtn.disabled = !(hasQty || noSelected);
  }

  function applyAutoMaterialsRecommendation() {
    const input = document.getElementById('workshop-participants-input');
    const participants = Math.max(0, parseInt((input && input.value) || '0', 10) || 0);
    workshopParticipants = participants;
    const recommendedPackQty = Math.max(1, Math.ceil(participants / 3));
    const recommendedRubansQty = 2;

    let recommendedMousseQty = 0;
    let recommendedMousseSupportQty = 0;

    const hasTableauBienvenue = Array.from(document.querySelectorAll('.element-item.selected')).some(function (item) {
      const title = normalizeRecommendationText(item.querySelector('.element-item-label')?.textContent || '');
      return title.includes('tableau') && title.includes('bienvenue');
    });
    if (hasTableauBienvenue) recommendedMousseQty += 1;

    const selectedDecorationEl = document.querySelector('.decoration-item.selected');
    const selectedDecorationTitle = normalizeRecommendationText(
      (selectedDecorationEl && selectedDecorationEl.getAttribute('data-decoration-title')) ||
      (selectedDecorationEl && selectedDecorationEl.querySelector('.decoration-item-label')?.textContent) ||
      ''
    );
    const tablesInput = document.getElementById('tables-quantity');
    const tablesQuantity = tablesInput ? (parseInt(tablesInput.value, 10) || 0) : 0;
    const hasPiqueCenterpiece =
      selectedDecorationTitle.includes('pique') ||
      selectedDecorationTitle.includes('coupelle') ||
      selectedDecorationTitle.includes('doree') ||
      selectedDecorationTitle.includes('dorée');
    if (hasPiqueCenterpiece) {
      recommendedMousseQty += Math.max(0, tablesQuantity);
    }

    const th = readTableHonneurState();
    if (th.choice === 'fresh' && th.suboption === 'compositions-piquee') recommendedMousseQty += 2;
    if (th.choice === 'fresh' && th.suboption === 'grosse-composition') recommendedMousseSupportQty += 2;

    const archeChoice = readArcheState();
    if (archeChoice === 'fresh' || archeChoice === 'artificial') recommendedMousseQty += 4;

    setMaterialQuantity(getMaterialCardByKeywords(['essentiel', 'fleuriste']), recommendedPackQty);
    setMaterialQuantity(getMaterialCardByKeywords(['ruban', 'satin']), recommendedRubansQty);
    setMaterialQuantity(getMaterialCardByKeywords(['mousse'], ['support']), recommendedMousseQty);
    setMaterialQuantity(getMaterialCardByKeywords(['mousse', 'support']), recommendedMousseSupportQty);

    const noMaterialsBtn = document.getElementById('no-materials-btn');
    const hasAnyRecommendedQty = [recommendedPackQty, recommendedRubansQty, recommendedMousseQty, recommendedMousseSupportQty].some(function (qty) {
      return qty > 0;
    });
    if (noMaterialsBtn && hasAnyRecommendedQty) {
      noMaterialsBtn.classList.remove('selected');
    }
    updateStep15MaterialsValidation();
  }

  function initStep14() {
    const validateStep14 = document.getElementById('validate-step-14');
    const workshopInput = document.getElementById('workshop-participants-input');
    if (!validateStep14 && !workshopInput) return;

    function updateStep14Validation() {
      if (!validateStep14 || !workshopInput) return;
      const n = parseInt(String(workshopInput.value || '').trim(), 10);
      validateStep14.disabled = !(Number.isFinite(n) && n >= 1);
      workshopParticipants = Number.isFinite(n) && n >= 1 ? n : 0;
    }

    if (workshopInput && !workshopInput.dataset.qv2Bound) {
      workshopInput.dataset.qv2Bound = '1';
      workshopInput.addEventListener('input', updateStep14Validation);
      workshopInput.addEventListener('change', updateStep14Validation);
    }
    updateStep14Validation();
  }

  function initStep15() {
    const seeMoreLink = document.getElementById('materials-see-more');
    if (seeMoreLink && !seeMoreLink.dataset.qv2Bound) {
      seeMoreLink.dataset.qv2Bound = '1';
      seeMoreLink.addEventListener('click', function (e) {
        e.preventDefault();
        const grid = document.getElementById('materials-grid');
        if (!grid) return;
        const expanded = grid.classList.toggle('show-all');
        this.textContent = expanded ? 'VOIR MOINS' : 'VOIR PLUS';
      });
    }

    document.querySelectorAll('.material-help-btn').forEach(function (btn) {
      if (btn.dataset.qv2Bound) return;
      btn.dataset.qv2Bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openMaterialHelpModal(this.getAttribute('data-material-help'));
      });
    });

    document.querySelectorAll('[data-close-modal]').forEach(function (closeBtn) {
      if (closeBtn.dataset.qv2Bound) return;
      closeBtn.dataset.qv2Bound = '1';
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const modalId = this.getAttribute('data-close-modal');
        const modal = modalId ? document.getElementById(modalId) : null;
        if (modal) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });

    document.querySelectorAll('.material-help-modal .modal-overlay').forEach(function (overlay) {
      if (overlay.dataset.qv2Bound) return;
      overlay.dataset.qv2Bound = '1';
      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const modal = this.closest('.material-help-modal');
        if (modal) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });

    document.querySelectorAll('.material-item').forEach(function (item) {
      if (item.dataset.qv2Bound) return;
      item.dataset.qv2Bound = '1';

      const materialId = item.getAttribute('data-material-id');
      const quantityInput = item.querySelector('#material-quantity-' + materialId);
      const minusBtn = item.querySelector('.quantity-minus[data-material-id="' + materialId + '"]');
      const plusBtn = item.querySelector('.quantity-plus[data-material-id="' + materialId + '"]');

      function updateMaterialQuantityState() {
        if (!quantityInput || !minusBtn) return;
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        minusBtn.disabled = currentValue <= 0;
        quantityInput.disabled = currentValue <= 0;
        item.classList.toggle('selected', currentValue > 0);
        if (currentValue > 0) {
          const noBtn = document.getElementById('no-materials-btn');
          if (noBtn && noBtn.classList.contains('selected')) noBtn.classList.remove('selected');
        }
      }

      item.addEventListener('click', function (e) {
        if (
          e.target.closest('.material-help-btn') ||
          e.target.closest('.image-zoom-btn') ||
          e.target.closest('.quantity-btn') ||
          e.target.closest('.quantity-input')
        ) {
          e.stopPropagation();
          return;
        }
        if (!quantityInput) return;
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        quantityInput.value = currentValue > 0 ? 0 : 1;
        updateMaterialQuantityState();
        updateStep15MaterialsValidation();
      });

      if (minusBtn && quantityInput) {
        minusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(quantityInput.value, 10) || 0;
          if (currentValue > 0) {
            quantityInput.value = currentValue - 1;
            updateMaterialQuantityState();
            updateStep15MaterialsValidation();
          }
        });
      }

      if (plusBtn && quantityInput) {
        plusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(quantityInput.value, 10) || 0;
          quantityInput.value = currentValue + 1;
          updateMaterialQuantityState();
          updateStep15MaterialsValidation();
        });
      }

      updateMaterialQuantityState();
    });

    const noMaterialsBtn = document.getElementById('no-materials-btn');
    if (noMaterialsBtn && !noMaterialsBtn.dataset.qv2Bound) {
      noMaterialsBtn.dataset.qv2Bound = '1';
      noMaterialsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.material-item').forEach(function (matItem) {
          matItem.classList.remove('selected');
          const matId = matItem.getAttribute('data-material-id');
          const qtyInput = matItem.querySelector('#material-quantity-' + matId);
          const minus = matItem.querySelector('.quantity-minus[data-material-id="' + matId + '"]');
          if (qtyInput) {
            qtyInput.value = 0;
            qtyInput.disabled = true;
          }
          if (minus) minus.disabled = true;
        });
        this.classList.toggle('selected');
        updateStep15MaterialsValidation();
      });
    }

    updateStep15MaterialsValidation();
  }

  function initSteps1415() {
    if (
      !document.querySelector('[data-qv2-section="14-15"]') &&
      !document.getElementById('validate-step-14') &&
      !document.getElementById('validate-step-15')
    ) return;

    initMaterialHelpDelegation();
    initMaterialZoomDelegation();
    initLightboxBindings();
    initStep14();
    initStep15();
  }

  function onStepShown(stepNumber) {
    if (stepNumber === 14) {
      initSteps1415();
    }
    if (stepNumber === 15) {
      initSteps1415();
      applyAutoMaterialsRecommendation();
      setTimeout(applyAutoMaterialsRecommendation, 100);
    }
  }

  window.QV2_STEPS_14_15 = {
    init: initSteps1415,
    onStepShown: onStepShown,
    applyAutoMaterialsRecommendation: applyAutoMaterialsRecommendation
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSteps1415);
  } else {
    initSteps1415();
  }
})();
